import { useTranslation } from "react-i18next";
import { number, object, string, unknown } from "zod";
import { AppStorage } from "../services/AppStorage";

export const useHomeEditSchema = () => {
  const { t } = useTranslation();
  const postalCodeMin = AppStorage().get("countryCode") === "PL" ? 6 : 4;

  const homeEditSchema = object({
    address: object({
      city: string().min(1, t("validation.address")),
      type: string().optional().nullable(),
      notes: string().optional().nullable(),
      postalOrZipCode: string().min(postalCodeMin, t("validation.postalCode")),
      streetAddress1: string().min(1, t("validation.address")),
      streetAddress2: string().optional().nullable(),
      doorCode: string().optional().nullable(),
      floorArea: number().min(10, { message: t("validation.minSurface", { minSize: 10 }) }),
      name: string().optional().nullable(),
    }),
    meta: object({
      keyInfo: string(),
      willCustomerBePresent: unknown().refine((value) => value !== "deselected", {
        message: t("validation.pickOption"),
      }),
    }).refine(
      (schema) => !(schema.willCustomerBePresent === false && schema.keyInfo?.length === 0),
      {
        message: t("validation.keyInfo"),
      },
    ),
  });

  return homeEditSchema;
};
